export default class SearchBar {
    constructor(headerContainerEl) {
        this.headerContainerEl = headerContainerEl
        this.searchBars = document.querySelectorAll(".search-bar")

        this.navToggleBtn = headerContainerEl.querySelector("#nav_search_toggle")
        this.navSearchBar = headerContainerEl.querySelector("#nav_search_bar .search-bar")
        this.backdrop = headerContainerEl.querySelector(".search-backdrop")

        if (this.searchBars.length > 0) this.initEventListeners()
        if (document.getElementById("search_no_query")) {
            this.navToggleBtn.classList.add("nav-highlight");
        }
    }

    initEventListeners() {
        const isToggleBar = bar => bar.classList.contains("search-bar-toggle")

        const closeSearchbarIfToggle = bar => {
            if (isToggleBar(bar)) this.toggleSearchbar(false)
        }

        this.searchBars.forEach(searchBar => {
            const input     = searchBar.querySelector(".search-input")
            const resetBtn  = searchBar.querySelector(".search-reset")
            const searchBtn = searchBar.querySelector(".search-link")

            // Update hrefs and values of all searchbars when typing
            input.addEventListener('input', () => this.updateValues(input.value))
            input.addEventListener('keydown', e => {
                // Search on enter if input is not empty
                if (e.key === 'Enter') {
                    e.preventDefault()
                    input.value.trim() && searchBtn.click()
                }

                // Reset input value on escape (and close searchbar)
                if (e.key === 'Escape') {
                    this.updateValues('')
                    closeSearchbarIfToggle(searchBar)
                }
            });
            // Reset input value on escape (and close searchbar)
            resetBtn.addEventListener('click', () => {
                this.updateValues('')
                closeSearchbarIfToggle(searchBar)
            })

            // Close searchbar "on blur" and keep input value
            this.backdrop.addEventListener('click', () => {
                closeSearchbarIfToggle(searchBar)
            })
        })
        // Open/focus searchbar
        this.navToggleBtn.addEventListener('click', () => {
            const barInput = this.searchBars[this.searchBars.length === 1 ? 0 : 1].querySelector(".search-input")
            if (this.searchBars.length === 1) this.toggleSearchbar()
            setTimeout(() => barInput.focus(), this.searchBars.length === 1 ? 100 : 0)
        })
    }

    toggleSearchbar(open = true) {
        this.headerContainerEl.classList.toggle("active-search", open)
    }

    updateHref(value, link) {
        if (value) {
            const newHref = `${link.dataset.url}?q=${encodeURIComponent(value)}`
            link.setAttribute('href', newHref)
            link.classList.remove('disabled')
        } else {
            link.setAttribute('href', link.dataset.url)
            link.classList.add('disabled')
        }
    }

    updateValues(value) {
        this.searchBars.forEach(bar => {
            const link = bar.querySelector(".search-link")
            const input = bar.querySelector(".search-input")

            input.value = value
            this.updateHref(value, link)
        })
    }
}
